<template>
 <div class="appCen">
    <div class="iframeOuterDiv">
        <div class="f-default-product">
            <div class="module-headline">
            仿真系统
        </div>
         <div class="product-container">
            <div class="product-card" v-for="(item, index) in myAppList" :key="item.id">
                <!--  <el-badge value="即将过期" class="item"  v-if="item.overTime"></el-badge> -->
               <img :src="item.thumb" alt=""> 
                 <div class="product-card-item-wrap">
                 <div class="card-name">{{item.appName}}</div>
                    <div class="card-description flex align-cen" >
                       <span v-if="item.useTime" :style="item.overTime ? {'color' : 'red'} : ''"> 
                        使用时间：{{item.useTime}}
                        </span>
                       
                        <span v-if="!item.useTime && item.payType == 1"> 使用时间：免费应用无时间限制</span>
                          <span v-if="!item.useTime && item.payType == 2"> 使用时间：无时间限制</span>
                    </div>
                     <div class="card-description flex align-cen" >
                       <span> 
                        账号个数：{{item.accountNum || '无限'}}
                        </span>
                       
                    </div>
                     <div class="WordsLink_word-wrap flex align-cen">
                        <div @click="openDet(item)" v-if="item.payType == 1">去下载<span class="icon-al-download"></span></div>
                        <div @click="openDet(item)" v-if="item.payType == 2" class="mft">
                          <span v-if="item.state == '2'">立即开通</span>
                           <span v-if="item.state == '1'">去升级</span>
                           <span v-if="item.state == '1' && item.overTime">立即续费</span>
                           <span class="icon-al-shoppingcart"></span>
                        </div>
                    </div>
                </div>
            </div>
         </div>
        </div>
    </div>
 </div>
</template>
<script>
import { appAllList} from "@/api/enterprise/index"; // 控制中心基础信息
export default {
    data() {
        return {
        myAppList:[],
        businessInfo:{},
        officialType:''
        }
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.officialType = this.$locaStorage.setAge().get('officialType')
        this.getappAllList()
    },
    methods: {
         // 打开未开通详情
    openDet(data){
      let appId = data ? data.id : 'RASO20220930001'
     const newurl = this.$router.resolve({name: 'endowloadDetail', query: {id: appId,type:2}})
       window.open(newurl.href,'_blank')
    },
        getappAllList(){
            appAllList({businessId:this.businessInfo.id,officialType:this.officialType},'enterprise').then(res => {
                this.myAppList = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.appCen {
  position: relative;
  .iframeOuterDiv {
    max-width: 1344px;
    margin: 0 auto;
    height: auto;
    min-height: auto;
    padding: 20px 32px 0;
    box-sizing: border-box;
        .f-default-product{
    display: block;
    width: 100%;
    height: auto;
    text-align: left;
    .module-headline{
    height: 44px;
    line-height: 24px;
    padding-bottom: 20px;
    color: #333;
    box-sizing: border-box;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 20px;
    position: relative;
    }
    .module-headline::before{
        content: "";
    position: relative;
    top: 5px;
    display: inline-block;
    vertical-align: top;
    margin-right: 8px;
    width: 4px;
    height: 16px;
    background: #2893f1;
    border-radius: 3px;
    }
    .product-container{
        margin-bottom: 4px;
        width: 100%;
      .product-card{
        width: calc((100% - 3 * 32px) / 4);
            position: relative;
            margin: 0 20px 20px 0;
            display: inline-block;
            vertical-align: top;
            max-width: 296px;
            min-width: 260px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 100%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 100%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 13px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
    .appcennone{
    margin: 50px auto;
    width: 370px;
    height: 280px;
    .portal_def_icon{
      width: 350px;
      height: 206px;
    background: url('../../assets/images/shopOrderList_default.png') no-repeat 0 0;
    margin: 0 auto;
    }
    .portal_def_subHeadline{
      color: #90909e;
    font-size: 16px;
        display: block;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 32px;
    margin-bottom: 6px;
    }
    }
    }
    }
}
::v-deep{
    .el-badge {
      position: absolute;
    top: -8px;
    right: -6px;
    }
}
</style>